import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LogoAnimatedSvg from "./LogoAnimatedSvg";

/**
 * Signature on-load moment: a black curtain with the BRA logo drawing itself,
 * gold shimmer sweep, and then lifting to reveal the site.
 * Auto-dismisses after 2.4s.
 */
export default function Preloader() {
    const [gone, setGone] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setGone(true), 2400);
        return () => clearTimeout(t);
    }, []);

    return (
        <AnimatePresence>
            {!gone && (
                <motion.div
                    initial={{ y: 0 }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 1.05, ease: [0.76, 0, 0.24, 1] }}
                    className="fixed inset-0 z-[100] bg-[#0b0b0b] flex flex-col items-center justify-center"
                    data-testid="preloader"
                >
                    {/* Grain */}
                    <div className="noise-overlay" style={{ zIndex: 1 }} />
                    {/* Diagonal decorative lines */}
                    <svg
                        className="absolute inset-0 w-full h-full opacity-[0.08] pointer-events-none"
                        aria-hidden
                    >
                        <defs>
                            <pattern id="pl-grid" width="80" height="80" patternUnits="userSpaceOnUse">
                                <path d="M 80 0 L 0 0 0 80" fill="none" stroke="#C89B3C" strokeWidth="0.5" />
                            </pattern>
                        </defs>
                        <rect width="100%" height="100%" fill="url(#pl-grid)" />
                    </svg>

                    <div className="relative z-10 flex flex-col items-center">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7 }}
                            className="text-[10px] uppercase tracking-[0.5em] text-[#C89B3C] mb-8"
                        >
                            Est. 1984 · Bangalore
                        </motion.div>

                        <LogoAnimatedSvg size={160} />

                        <div className="mt-8 overflow-hidden">
                            <motion.div
                                initial={{ y: "100%" }}
                                animate={{ y: "0%" }}
                                transition={{
                                    delay: 0.7,
                                    duration: 0.8,
                                    ease: [0.2, 0.7, 0.2, 1],
                                }}
                                className="font-display text-white text-3xl md:text-4xl tracking-[0.06em] uppercase"
                            >
                                BRA Sheriff
                            </motion.div>
                        </div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 1.4, duration: 0.5 }}
                            className="mt-3 text-[10px] uppercase tracking-[0.35em] text-[#bebebe]"
                        >
                            Builders &amp; Developers
                        </motion.div>

                        {/* Progress bar */}
                        <div className="mt-10 w-56 h-[2px] bg-white/10 overflow-hidden">
                            <motion.div
                                initial={{ width: 0 }}
                                animate={{ width: "100%" }}
                                transition={{ duration: 2.2, ease: [0.2, 0.7, 0.2, 1] }}
                                className="h-full bg-[#C89B3C]"
                            />
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
